import React from 'react';
import AnnotationHistory from '../../../components/AnnotationHistory';
import type { InspectionMediaData } from '../inspectionMediaTypes';

interface InspectionHistoryPanelProps {
  inspectionId: string;
  imageData: InspectionMediaData;
  onClose: () => void;
}

const InspectionHistoryPanel: React.FC<InspectionHistoryPanelProps> = ({ inspectionId, imageData, onClose }) => {
  return (
    <aside className="w-[340px] shrink-0 overflow-y-auto bg-white shadow-sm">
      <AnnotationHistory inspectionId={inspectionId} imageData={imageData} onClose={onClose} />
    </aside>
  );
};

export default InspectionHistoryPanel;
